// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ti2Y","logo":"styles_logo__3zH5d","logo__image":"styles_logo__image__3kWjN","text":"styles_text__2UAVe","text__label":"styles_text__label__3R9u-"};